import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useEffect } from 'react';

import type { TWorkplaceFormFields } from 'entities/creditForm';
import { useGetJobPositions } from 'entities/creditForm';

export const useInitialJobPositionSuggestions = () => {
  const [getJobPositions] = useGetJobPositions();
  const { getValues, setValue, trigger } = useFormContext<TWorkplaceFormFields>();

  const getJobPositionsSuggests = useCallback(
    async (value: string) => {
      const suggestions = await getJobPositions(value, true).unwrap();

      const prefilledSuggestion = suggestions.find(
        (suggest) => suggest.value.toLowerCase().trim() === value?.toLowerCase().trim(),
      );

      if (!prefilledSuggestion) {
        return;
      }

      setValue('jobTitle', prefilledSuggestion);
      trigger('jobTitle');
    },
    [getJobPositions, setValue, trigger],
  );

  useEffect(() => {
    const jobTitleValue = getValues('jobTitle.value');
    if (jobTitleValue) {
      getJobPositionsSuggests(jobTitleValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
